var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6693 14.6667C15.6148 14.6667 18.0026 12.2789 18.0026 9.33333C18.0026 6.38781 15.6148 4 12.6693 4C9.72375 4 7.33594 6.38781 7.33594 9.33333C7.33594 12.2789 9.72375 14.6667 12.6693 14.6667Z",
    fill: "#F3B763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3307 28V25.3333C29.3307 22.8482 27.631 20.7601 25.3307 20.168M20.6641 4.38768C22.6186 5.17886 23.9974 7.09508 23.9974 9.33333C23.9974 11.5716 22.6186 13.4878 20.6641 14.279M22.6641 28C22.6641 25.515 22.6641 24.2725 22.2581 23.2924C21.7168 21.9855 20.6785 20.9473 19.3717 20.406C18.3916 20 17.1491 20 14.6641 20H10.6641C8.17904 20 6.93653 20 5.95642 20.406C4.6496 20.9473 3.61134 21.9855 3.07004 23.2924C2.66406 24.2725 2.66406 25.515 2.66406 28M17.9974 9.33333C17.9974 12.2789 15.6096 14.6667 12.6641 14.6667C9.71854 14.6667 7.33073 12.2789 7.33073 9.33333C7.33073 6.38781 9.71854 4 12.6641 4C15.6096 4 17.9974 6.38781 17.9974 9.33333Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingIcon);
export default __webpack_public_path__ + "static/media/connecting-icon.b1d4918c0d0bef475b13c9317da01562.svg";
export { ForwardRef as ReactComponent };